export const normalizeTicketUpdatePayload = payload => {
  if (!payload || !Object.prototype.hasOwnProperty.call(payload, "property")) {
    return payload;
  }

  if (payload.value !== undefined) {
    return payload;
  }

  return {
    ...payload,
    value: null,
  };
};
